import React from 'react';
import { Box, Button, Placeholder } from '@dion-web/ui';
import styled from '@emotion/styled';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

const ErrorContainer = styled(Box)`
  width: 100vw;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorBoundary: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();

  const tTitle = t('widgets.errorBoundary.title');
  const tDesc = t('widgets.errorBoundary.desc');
  const tReload = t('widgets.errorBoundary.reload');

  return (
    <ReactErrorBoundary
      fallback={
        <ErrorContainer>
          <Placeholder
            title={tTitle}
            desc={tDesc}
            icon="Error"
            controls={
              <Button
                onClick={() => {
                  window.location.reload();
                }}
              >
                {tReload}
              </Button>
            }
          />
        </ErrorContainer>
      }
    >
      {children}
    </ReactErrorBoundary>
  );
};
